import { getEstados } from '../estadoService';

// Orden fijo de estados ART según el orden especificado
const ORDEN_ESTADOS_ART = [
    'Ingreso del trámite',
    'Turno médico asignado',
    'Espera de documentación',
    'Enviados a la médica',
    'Preparando telegrama',
    'Telegrama enviado',
    'Citación ART',
    'Respuesta ART',
    'Pendiente de Anexo',
    'Iniciado en comisión médica',
    'Resolución SRT',
    'Judicializado',
    'Finalizado'
];

/**
 * Obtiene el siguiente estado en la secuencia de ART
 * @param {string} estadoActual - Nombre del estado actual
 * @param {string} nuevoNombre - Nombre del estado al que se desea avanzar (opcional)
 * @returns {Promise<Object>} El objeto del estado siguiente con su ID
 */
export const obtenerSiguienteEstadoART = async (estadoActual, nuevoNombre = null) => {
    try {
        const estados = await getEstados();

        // Filtrar solo estados con ámbito 'ART'
        const estadosART = estados.filter(estado => estado.ambito === 'ART');

        if (!estadosART || estadosART.length === 0) {
            throw new Error('No hay estados ART registrados en el sistema');
        }

        let siguienteEstado = null;

        if (nuevoNombre) {
            // Si se especifica un estado destino, buscarlo directamente
            siguienteEstado = estadosART.find(e => e.nombre === nuevoNombre);
            if (!siguienteEstado) {
                throw new Error(`Estado '${nuevoNombre}' no encontrado en los estados ART`);
            }
        } else {
            // Buscar el siguiente estado en la secuencia predefinida
            const indiceActual = ORDEN_ESTADOS_ART.indexOf(estadoActual);

            if (indiceActual === -1) {
                throw new Error(`Estado actual '${estadoActual}' no reconocido en la secuencia ART`);
            }

            if (indiceActual >= ORDEN_ESTADOS_ART.length - 1) {
                throw new Error('El trámite ya está en el último estado de la secuencia ART');
            }

            const nombreSiguiente = ORDEN_ESTADOS_ART[indiceActual + 1];
            siguienteEstado = estadosART.find(e => e.nombre === nombreSiguiente);

            if (!siguienteEstado) {
                throw new Error(`Estado siguiente '${nombreSiguiente}' no encontrado en la base de datos`);
            }
        }

        return siguienteEstado;
    } catch (error) {
        console.error('Error en obtenerSiguienteEstadoART:', error);
        throw error;
    }
};

/**
 * Obtiene todos los estados ART ordenados según la secuencia
 * @returns {Promise<Array>} Array de estados ART ordenados
 */
export const obtenerEstadosARTOrdenados = async () => {
    try {
        const estados = await getEstados();
        const estadosART = estados.filter(estado => estado.ambito === 'ART');

        // Ordenar según el orden predefinido
        return ORDEN_ESTADOS_ART
            .map(nombre => estadosART.find(e => e.nombre === nombre))
            .filter(estado => estado !== undefined);
    } catch (error) {
        console.error('Error en obtenerEstadosARTOrdenados:', error);
        throw error;
    }
};

/**
 * Obtiene un estado ART específico por nombre
 * @param {string} nombre - Nombre del estado
 * @returns {Promise<Object>} El objeto del estado
 */
export const obtenerEstadoARTPorNombre = async (nombre) => {
    try {
        const estados = await getEstados();
        const estado = estados.find(e => e.ambito === 'ART' && e.nombre === nombre);

        if (!estado) {
            throw new Error(`Estado ART '${nombre}' no encontrado`);
        }

        return estado;
    } catch (error) {
        console.error('Error en obtenerEstadoARTPorNombre:', error);
        throw error;
    }
};

export default {
    obtenerSiguienteEstadoART,
    obtenerEstadosARTOrdenados,
    obtenerEstadoARTPorNombre,
    ORDEN_ESTADOS_ART
};

